/* @flow */

export default {
  root: {
    width: 10,
    height: 10,
  },
  'root-large': {
    width: 18,
    height: 18,
  },
};
